import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { OptionListPageContainer } from "@/components/features/items/list/option/container";

import { useGetOptionListPageParams } from "./_hooks/use-get-option-list-page-params";

export const OptionListPage = () => {
	const { hotelID } = useGetOptionListPageParams();

	return (
		<PageMeta title="オプションの一覧" url={generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })}>
			<OptionListPageContainer hotelID={hotelID} />
		</PageMeta>
	);
};

OptionListPage.displayName = "OptionListPage";
